module.exports = __webpack_public_path__ + "static/img/2.ee08fd44.jpg";